<template>
  <div>
    <div class="header header-default">
      <div class="container d-flex">
        <div class="header-logo">
          <a href="/beta" class="logo-link header-nav-link ">
            <img
              src="/beta/static/logo.svg"
              style="width: 45px;margin-right: 5px"
            /><b  v-if="isAuthenticated" class="text-womia">Womia Box </b><b  v-if="!isAuthenticated" class="text-womia not-authenticated">Womia Box </b><small>By WOMIA</small>
          </a>
        </div>

        <div class="header-nav nav">
          <div class="container">
          <ul class="nav pull-right">
            <li v-if="!isAuthenticated">
              <div class="header-nav-item">
                <a href="/beta/contact-us" class="header-nav-link "
                  >Contact Us</a
                >
              </div>
            </li>
            <li v-if="!isAuthenticated"
              class="separator"
              style=" border-left: 1px solid #dbdbdb;  margin: 5px 0;"
            ></li>
            <li v-if="!isAuthenticated">
              <div class="header-nav-item">
                <router-link :to="{ name: 'Login' }" class="header-nav-link"
                  >Login</router-link
                >
              </div>
            </li>
            <li v-if="isAuthenticated && !hasRole(['admin'])">
              <div class="header-nav-item">
                <a
                  href="#"
                  class=" header-nav-link dropdown-toggle mr-md-2"
                  id="bd-versions"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img
                    v-if="!currentUser.picture"
                    src="/beta/static/default-user-128.png"
                    class="user-img"
                    width="128"
                    height="128"
                    alt=""
                  />
                  <img
                    v-if="currentUser.picture"
                    :src="currentUser.picture.slug | media({ width: '128' })"
                    class="user-img"
                    alt=""
                  />
                  <span class="hidden-md hidden-sm hidden-xs">{{
                    currentUser.nickname || currentUser.email
                  }}</span>
                  <b class="caret"></b>
                </a>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="bd-versions"
                >
                  <router-link class="dropdown-item" :to="{ name: 'Profile' }"
                    >My Profile</router-link
                  >
                  <router-link
                    class="dropdown-item"
                    :to="{ name: 'Home', query: { search: 'MyApps' } }"
                    >My Requests</router-link
                  >
                  <router-link
                    class="dropdown-item"
                    :to="{ name: 'DashboardDeveloper' }"
                    >Data provider</router-link
                  >
                  <div class="dropdown-divider"></div>
                  <a
                    class="dropdown-item"
                    href="#logout"
                    @click="logoutGoHome()"
                    >Log out</a
                  >
                </div>
              </div>
            </li>
            <li v-if="isAuthenticated && hasRole(['admin'])">
              <router-link
                class="btn rounded-pill"
                :to="{ path: '/beta/admin/product' }" style="display: inline; color: white;"
                >Return to catalog Management</router-link>
            </li>
          </ul>
          <div v-if="!isAuthenticated">
            <router-link
              :to="{ name: 'Signup' }"
              class="btn btn-primary get-started fw-bold rounded-pill"
              >Create Account</router-link
            >
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuex from "vuex";

export default {
  name: "navbar",
  methods: {
    ...Vuex.mapActions(["login", "logout"]),
    logoutGoHome() {
      this.logout();
      this.$router.push({ path: "/" });
    },
  },
  computed: {
    ...Vuex.mapGetters([
      "isAuthenticated",
      "currentUser",
      "isLoading",
      "hasRole"
    ])
  },
};
</script>

<style scoped>
.header .user-img {
  float: left;
  width: 36px;
  height: 36px;
  border-radius: 40px;
  margin: 0px 10px 00px 0;
}

.header .navbar-nav > li > .dropdown-menu {
  margin-top: 0;
  border-top: 1px solid #f2f3f4;
  box-shadow: 0 13px 25px -2px rgba(0, 0, 0, 0.2);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.header .dropdown-menu {
  padding: 10px;
  min-width: 100px;
}

.dropdown-item,
.dropdown-menu > li > a {
  display: block;
  padding: 5px 15px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  text-decoration: none;
}

.dropdown-divider,
.dropdown-menu .divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}

.header-nav .nav > li.open > a,
.header-nav .nav > li.open > a:focus,
.header-nav .nav > li.open > a:hover,
.header-nav .nav > li > a:focus,
.header-nav .nav > li > a:hover {
  color: #707478;
}

.header-nav .nav > li > a {
  line-height: 56px;
}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

.header .dropdown-menu {
  padding: 10px;
  min-width: 100px;
}

.dropdown-item,
.dropdown-menu > li > a {
  display: block;
  padding: 5px 15px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  text-decoration: none;
}

.dropdown-divider,
.dropdown-menu .divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}

.header-nav .nav > li {
  float: left;
}

.nav > li,
.nav > li > a {
  position: relative;
  display: block;
}

.open > .dropdown-menu {
  display: block;
}

.app {
  top: 0;
  left: 0;
  right: 0;
  position: absolute;
}
.header .user-img{
  float: none;
}
.dropdown-item:active{
  background-color: #E95913!important;
  color: white!important;
}
.get-started {
  background: #E95913 !important;
}
.get-started:hover {
  background:  #E95913af !important;
}
@media (max-width: 991.98px){
.header.header-default .header-nav{
  display: ruby-text;
} }

@media (max-width: 997px) {
  .header-nav.nav {
    display: contents !important;
  }
  .container {
    display: contents;
  }
  .nav .pull-right {
    margin-top: 10px;
  } 
   .rounded-pill {
    margin-top: 10px;
  } 
}
@media (max-width: 389px) {
  .header-nav.nav {
    display: block !important;
  }}
  @media (max-width: 507px) {
  .not-authenticated {
    display: none !important; ;
  }}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue